import { useState, useEffect, useContext } from 'react';
import ContextStates from '../context/ContextStates';
import { MdClose } from "react-icons/md";
import { Url } from './Url';

const DetallePedido = () => {
    const [descuentos, setDescuentos] = useState([])
    const [total, setTotal] = useState(0)
    const { auxVenta, auxTotal, precio, venta, setVenta } = useContext(ContextStates);

    useEffect(() => {
        const calcTotal = () => {
            let aux = 0;
            let rData = [...descuentos]
            auxVenta.forEach(element => {
                if (!precio) {
                    if (element.tipopromo === '1' || element.tipopromo === '2') {
                        aux = aux + parseFloat(element.preciopromocion * element.cantidad);
                        let montoDesc = parseFloat(element.precio * element.cantidad) - parseFloat(element.preciopromocion * element.cantidad);
                        let descuento = {
                            id: element.id,
                            descripcion: element.descripcion,
                            monto: montoDesc
                        }
                        rData.push(descuento)
                    }
                    else {
                        if (element.tipopromo === '3') {
                            let precio = 0;
                            if (element.cantidad >= element.cantidadminima) {
                                let cantPromos = parseFloat(element.cantidad) / parseFloat(element.cantidadminima);
                                let cantPagos = element.cantidad - (parseFloat(element.cantidaddescuento) * cantPromos);
                                precio = cantPagos * parseFloat(element.precio);
                                let montoDesc = parseFloat(element.precio * element.cantidad) - precio;
                                let descuento = {
                                    id: element.id,
                                    descripcion: element.descripcion,
                                    monto: montoDesc
                                }
                                rData.push(descuento)
                            } else {
                                precio = parseFloat(element.cantidad) * parseFloat(element.precio);
                            }
                            aux = aux + precio;
                        } else {
                            aux = aux + parseFloat(element.precio * element.cantidad);
                        }
                    }
                }
                else {
                    aux = aux + parseFloat(element.preciopormayor * element.cantidad);
                }
            });
            setDescuentos(rData)
            setTotal(aux)
        }
        calcTotal()
    }, [auxVenta])

    const calcTotal = (item) => {
        let precio = 0;
        if (item.cantidad >= item.cantidadminima) {
            let cantPromos = parseFloat(item.cantidad) / parseFloat(item.cantidadminima);
            let cantPagos = item.cantidad - (parseFloat(item.cantidaddescuento) * cantPromos);
            precio = cantPagos * parseFloat(item.precio);
        } else {
            precio = parseFloat(item.cantidad) * parseFloat(item.precio);
        }
        return (precio.toLocaleString("es-AR", { maximumFractionDigits: 2 }));
    }

    const handleDelete = (item) => {
        let rData = []
        venta.forEach(element => {
            //console.log("linea element ", element.idlinea, " - linea item ", item.idlinea)
            if (element.idlinea !== item.idlinea) {
                rData.push(element)
            }
        });
        setVenta(rData)
        localStorage.removeItem('localVenta');
        localStorage.setItem('localVenta', JSON.stringify(rData))

    }

    return (
        <div className="w-full mx-auto my-5 border border-gray-600 rounded-sm">

            {typeof auxVenta !== 'undefined' && auxVenta.map((item, index) => (

                <div key={index} className='w-full'>
                    <div className='w-full font-semibold flex mt-2 p-2'>
                        <div className='w-1/6 print:w-0'>
                            { item.imagen!=='' && (
                                <img className='w-1/3 object-cover rounded' src={Url + item.imagenes[0].imagen} />
                            )}
                        </div>
                        <div className='w-3/5 print:w-4/5 print:pl-2 print:pr-10'>
                            <p className='text-left print:text-xs'>{`${item.cantidad} x ${item.descripcion}`}</p>
                        </div>
                        <div className='w-1/5 print:pr-10'>
                            <p className='text-right print:text-xs'>${precio ? (parseFloat(item.preciopormayor) * parseFloat(item.cantidad)).caleString("es-AR", { maximumFractionDigits: 2 }) : item.tipopromo === '3' ? calcTotal(item) : (item.tipopromo === '1' || item.tipopromo === '2') ? (parseFloat(item.preciopromocion) * parseFloat(item.cantidad)).toLocaleString("es-AR", { maximumFractionDigits: 2 }) : ((parseFloat(item.precio)) * parseFloat(item.cantidad)).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                        </div>
                        <div className='w-1/6 print:w-0 md:w-1/12 ml-3 print:invisible'>
                            {venta && venta.length > 0 && (
                                <button
                                    className='bg-red-600 p-1 rounded text-white'
                                    onClick={() => handleDelete(item)}
                                >
                                    <MdClose />
                                </button>

                            )}
                        </div>
                    </div>
                    {typeof item.subproductos !== 'undefined' && item.subproductos.map((item, index) => (
                        <div key={index}>
                            {item.agregado === '1' && (
                                <div className='pl-10 mt-0'>
                                    <div className='print:pl-2 print:pr-10'>
                                        <p className='text-left ml-10 print:text-xs'>{item.descripcion}<span className='font-bold'>{item.precio !== '0' && (' - $ ' + item.precio)}</span></p>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                    <div className='w-full mt-2 p-2'>
                        {item.nota !== '' && (
                            <p><span className='font-semibold'>Nota: </span>{item.nota}</p>
                        )}
                    </div>
                </div>
            ))}
            <div className='w-full font-semibold flex mt-2 p-2'>
                <div className='w-full pl-2'>
                    <p className='text-left font-bold uppercase text-3xl print:text-sm'>Total</p>
                </div>
                <div className='w-full pr-10'>
                    <p className='text-right font-bold uppercase text-3xl print:text-sm'>${parseFloat(auxTotal).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                </div>
            </div>
            {typeof descuentos !== 'undefined' && descuentos.length > 0 && (
                <div className='w-full print:pl-2'>
                    <p className='text-left font-bold uppercase text-3xl print:text-sm'>Descuentos</p>
                </div>
            )}
            {typeof descuentos !== 'undefined' && descuentos.map((item, index) => (
                <div key={index} className='w-full'>
                    <div className='w-full print:pl-2 print:pr-10'>
                        <p className='text-left print:text-xs'>{`${item.descripcion}`}</p>
                    </div>
                    <div className='w-full print:pr-10'>
                        <p className='text-right print:text-xs'>$ {parseFloat(item.monto).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                    </div>
                </div>
            ))}


        </div>
    )

}

export default DetallePedido